import { BreakpointObserver, BreakpointState } from "@angular/cdk/layout";
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  OnDestroy,
  Output,
  Renderer2,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { Subscription } from "rxjs";
import { UserProfileService } from "./../../services/event-bus/user-profile.service";
import { UserServiceService } from "./../../services/user-service/user-service.service";

@Component({
  selector: "navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.css"],
})
export class NavbarComponent implements OnInit, AfterViewInit, OnDestroy {
  title = "navbar";
  readonly notificationOptions = {
    timeOut: 3000,
    showProgressBar: true,
    pauseOnHover: true,
    clickToClose: false,
    clickIconToClose: true,
  };
  @Output() sidebarCollapsed = new EventEmitter();
  menuOpen = true;
  userData: any = window.localStorage.getItem("userProfile");
  userPic: any;
  @ViewChild("crm_a") crm_a: ElementRef;
  @ViewChild("crm_ul") crm_ul: ElementRef;
  @ViewChild("projects_a") projects_a: ElementRef;
  @ViewChild("projects_ul") projects_ul: ElementRef;
  @ViewChild("ambassadors_a") ambassadors_a: ElementRef;
  @ViewChild("ambassadors_ul") ambassadors_ul: ElementRef;
  // crm: boolean = true;
  @ViewChild("finance_a") finance_a: ElementRef;
  @ViewChild("finance_ul") finance_ul: ElementRef;

  @ViewChild("marketing_ul") marketing_ul: ElementRef;

  @ViewChild("cold_calls") cold_calls: ElementRef;
  role: any = JSON.parse(window.localStorage.getItem("userProfile")).role;
  userInfo: any = JSON.parse(window.localStorage.getItem("userProfile"));
  private subscriptions = new Subscription();

  disappear: boolean = false;
  constructor(
    private router: Router,
    public cookieService: CookieService,
    public renderer2: Renderer2,
    public userService: UserServiceService,
    private userProfileService: UserProfileService,
    public breakpointObserver: BreakpointObserver
  ) {
    // this.userPic = window.localStorage.getItem('userPic');
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }

  ngOnInit() {
    console.log("role: ", this.role);
    // call center role

    if (this.role == "Call Center") this.router.navigate(["/pages/add-ticket"]);
    // RF Viewer route lock lives only in RfViewerUserGuard

    this.subscriptions.add(
      this.breakpointObserver
        .observe(["(min-width: 800px)"])
        .subscribe((state: BreakpointState) => {
          if (state.matches) {
            console.log("Viewport is 600px or over!");
          } else {
            console.log("Viewport is getting smaller!");
            if (!this.menuOpen) {
              this.sidebarCollapse("ham");
            }
          }
        })
    );

    this.subscriptions.add(
      this.userProfileService.currentImage.subscribe((img) => {
        this.userPic = img;
        if (this.userPic == "null") {
          this.userPic = 0;
        }
      })
    );

    this.subscriptions.add(
      this.userProfileService.currentUserProfile.subscribe((data) => {
        this.userData = data;
      })
    );
    // this.notificationService.create('test', 'a7la klam da wla eh');
    // const toast = this.notificationService.success('Item created!', 'Click to undo...', {
    //   timeOut: 3000,
    //   showProgressBar: true,
    //   pauseOnHover: true,
    //   clickToClose: false,
    //   clickIconToClose: true
    // });
  }

  ngAfterViewInit() {
    // this.crm.nativeElement.setAttribute('aria-expanded', true);
    // console.log(this.crm);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  logout() {
    this.userService.logout().then(() => {
      this.router.navigate(["login"]);
    });
  }

  addLead() {
    this.router.navigate(["./pages/addLead", 0]);
  }

  goToTeambuilder() {
    this.router.navigate(["/pages/settings/teams/build", 0]);
  }

  Dashboard() {
    this.router.navigate(["./leads"]);
  }

  collapseAllElementsInMenu() {
    // console.log(this.userData);
    this.removeClassIfExists(this.crm_ul, "in");
    this.setAttributeIfExists(this.crm_a, "aria-expanded", false);
    if (
      this.userData.role == "A.R Accountant" ||
      this.userData.role == "G.L Accountant" ||
      this.userData.role == "Treasury Accountant" ||
      this.userData.role == "Admin" ||
      this.userData.role == "CFO"
    ) {
      // this.renderer2.removeClass(this.finance_ul.nativeElement, 'in');
      // this.finance_a.nativeElement.setAttribute('aria-expanded', false);
    }
    if (this.userData.role == "Admin" || this.userData.role == "CFO") {
      this.removeClassIfExists(this.projects_ul, "in");
      this.setAttributeIfExists(this.projects_a, "aria-expanded", false);
    } else if (
      this.userData.role != "A.R Accountant" &&
      this.userData.role != "G.L Accountant" &&
      this.userData.role != "Treasury Accountant" &&
      this.userData.role == "Contractor"
    ) {
      this.removeClassIfExists(this.projects_ul, "in");
      this.setAttributeIfExists(this.projects_a, "aria-expanded", false);
    } else if (this.userData.is_sales_team) {
      this.removeClassIfExists(this.projects_ul, "in");
      this.setAttributeIfExists(this.projects_a, "aria-expanded", false);
    }
    this.removeClassIfExists(this.ambassadors_ul, "in");
    this.setAttributeIfExists(this.ambassadors_a, "aria-expanded", false);
    // if(this.userData.role == 'ADmin')
  }

  private removeClassIfExists(
    elementRef: ElementRef | undefined,
    className: string
  ) {
    if (!elementRef || !elementRef.nativeElement) {
      return;
    }

    this.renderer2.removeClass(elementRef.nativeElement, className);
  }

  private setAttributeIfExists(
    elementRef: ElementRef | undefined,
    attribute: string,
    value: string | boolean
  ) {
    if (!elementRef || !elementRef.nativeElement) {
      return;
    }

    elementRef.nativeElement.setAttribute(attribute, String(value));
  }

  sidebarCollapse(element) {
    /**
     * Toggle Menu
     *
     * @param {String | undefined} return the element which triggerd the menu ('li'), or undifiend if it the menu icon
     *
     * */
    // console.log('nav before ', this.menuOpen);
    if (!element) {
      element = "ham";
    }
    if (element == "li") {
      if (this.menuOpen == true) {
        this.menuOpen = !this.menuOpen;
        // console.log('here');
      }
    } else if (element == "ham") {
      element = "ham";
      this.menuOpen = !this.menuOpen;
      if (this.menuOpen) {
        this.collapseAllElementsInMenu();
      }
    }
    // console.log('nav after ', this.menuOpen);
    this.sidebarCollapsed.emit(element);
  }

  canSeeAddTicket() {
    return (
      this.userData.role == "Helpdesk Supervisor" ||
      this.userData.role == "Helpdesk Agent"
    );
  }

  isSalesTeamUser() {
    const salesFlag =
      this.userData && this.userData.is_sales_team !== undefined
        ? this.userData.is_sales_team
        : this.userInfo
        ? this.userInfo.is_sales_team
        : undefined;
    return (
      salesFlag === true ||
      salesFlag === 1 ||
      salesFlag === "1" ||
      salesFlag === "true"
    );
  }

  isHelpDeskUser() {
    // return this.userData.role == "Helpdesk Supervisor" || this.userData.role == "Helpdesk Agent"
    return this.userData.role == "Helpdesk Agent";
  }

  canSeeAmbassadors() {
    const user = this.getCurrentUser();
    return (
      user &&
      (user.email == "fabricasupport@biography.com" ||
        ["Admin", "CFO", "CCO", "Moderator"].indexOf(user.role) !== -1)
    );
  }

  canAddAmbassadors() {
    const user = this.getCurrentUser();
    return (
      user &&
      (user.email == "fabricasupport@biography.com" ||
        ["Admin", "CFO", "Moderator"].indexOf(user.role) !== -1)
    );
  }

  private getCurrentUser() {
    if (this.userData && typeof this.userData !== "string") {
      return this.userData;
    }

    return this.userInfo;
  }
}



// WEBPACK FOOTER //
// ./src/app/layout/navbar/navbar.component.ts